import { render, staticRenderFns } from "./FoodTrends.vue?vue&type=template&id=82b91e72&"
import script from "./FoodTrends.vue?vue&type=script&lang=js&"
export * from "./FoodTrends.vue?vue&type=script&lang=js&"
import style0 from "./FoodTrends.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports